module.exports = __webpack_public_path__ + "static/img/link1.1a0d95a7.png";